export interface TutorialVideo {
  id: number;
  title: string;
  desc?: string;
  duration?: string;
  vimeoId?: string;
}

export const tutorialVideos: TutorialVideo[] = [
  {
    id: 1,
    title: 'Administration, Setup, and Data Integration',
    desc: 'Set up your account, configure administrative settings, and connect your data sources to the platform.',
    duration: '2 min',
    vimeoId: '1214582572',
  },
  {
    id: 2,
    title: 'Use Case Inventory and Questionnaire Walkthrough',
    desc: 'Browse your AI use case inventory and learn how questionnaires are structured and navigated.',
    duration: '3 min',
    vimeoId: '1214586943',
  },
  {
    id: 3,
    title: 'Creating and Configuring Questionnaires',
    desc: 'Build custom questionnaires from scratch and configure their questions, sections, and settings.',
    duration: '3 min',
    vimeoId: '1214588133',
  },
  {
    id: 4,
    title: 'Lifecycles, Evidences, and Result Logic',
    desc: 'Understand how lifecycle stages, supporting evidence, and result logic work together to drive compliance outcomes.',
    duration: '2 min',
    vimeoId: '1214591804',
  },
  {
    id: 5,
    title: 'Configuring Lifecycles and Process Controls',
    desc: 'Define lifecycle stages and attach process controls to enforce governance steps across your AI models.',
    duration: '2 min',
    vimeoId: '1214594124',
  },
  {
    id: 6,
    title: 'Risk Profiles and Questionnaire Weights',
    desc: 'Configure risk profiles and assign weights to questionnaire sections to shape how risk scores are calculated.',
    duration: '5 min',
    vimeoId: '1214595236',
  },
  {
    id: 7,
    title: 'Governance Automations and MCP Server',
    desc: 'Set up automated governance workflows and connect the MCP server to streamline compliance tasks.',
    duration: '1 min',
    vimeoId: '1214596056',
  },
  {
    id: 8,
    title: 'Reporting, Monitoring, and Notifications',
    desc: 'Generate reports, monitor model activity in real time, and configure notifications to stay informed.',
    duration: '2 min',
    vimeoId: '1214596601',
  },
];
